export default __webpack_public_path__ + "static/media/personal_booking_icon_question.cc41b5a8.svg";